<!-- Start header -->
<div id="top-of-page"></div>
<lib-nav
  (openSidebar)="openSidebar()"
  [notify]="notify"
  (closeNotify)="closeNotify()"
>
</lib-nav>
<!-- End header -->

<div class="flex min-h-screen justify-center bg-white">
  <div class="relative flex flex-col">
    <div class="max-w-md px-4 sm:w-screen sm:max-w-3xl sm:px-6 lg:max-w-7xl">
      <div
        class="relative flex flex-col justify-center overflow-hidden px-6 py-8 sm:px-12 sm:pb-20 sm:pt-10"
      >
        <div class="text-center">
          <h2
            class="text-2xl font-medium uppercase tracking-wider text-black sm:text-3xl"
          >
            CUES Documents
          </h2>
        </div>
        <div class="mx-auto mt-2 w-10 border border-blue-500"></div>
      </div>
    </div>

    <div class="pb-32 lg:max-w-7xl">
      <div class="flex justify-center overflow-hidden">
        <ul class="w-full sm:max-w-xl">
          <li
            class="boder-gray-300 border-b"
            *ngFor="let node of nodes$ | async"
          >
            <a
              href="{{ node.url }}"
              target="{{ node.target }}"
              class="block hover:bg-gray-50"
            >
              <div class="flex items-center px-4 py-4 sm:px-6">
                <div class="min-w-0 flex-1 sm:flex sm:items-center">
                  <div class="flex items-center text-xl sm:text-2xl">
                    <p class="truncate text-wrap font-medium text-bluemine-600">
                      {{ node.title }}
                    </p>

                    <ng-container [ngSwitch]="node.type">
                      <ng-container *ngSwitchCase="'link'">
                        <app-arrow-top-right-on-square-outline-icon
                          size="20"
                          class="ml-2"
                        ></app-arrow-top-right-on-square-outline-icon>
                      </ng-container>
                      <ng-container *ngSwitchCase="'pdf'">
                        <svg
                          viewBox="0 0 128 128"
                          xml:space="preserve"
                          class="ml-2 h-5 w-5"
                        >
                          <path
                            d="M104 126H24c-5.514 0-10-4.486-10-10V12c0-5.514 4.486-10 10-10h40.687a9.932 9.932 0 0 1 7.07 2.929l39.314 39.314a9.932 9.932 0 0 1 2.929 7.07V116c0 5.514-4.486 10-10 10zM24 6c-3.309 0-6 2.691-6 6v104c0 3.309 2.691 6 6 6h80c3.309 0 6-2.691 6-6V51.313a6.044 6.044 0 0 0-1.757-4.242L68.929 7.757A5.96 5.96 0 0 0 64.687 6H24z"
                            style="fill: #fd4233"
                          />
                          <path
                            d="M95.21 80.32c-.07-.51-.48-1.15-.92-1.58-1.26-1.24-4.03-1.89-8.25-1.95-2.86-.03-6.3.22-9.92.73-1.62-.93-3.29-1.95-4.6-3.18-3.53-3.29-6.47-7.86-8.31-12.89.12-.47.22-.88.32-1.3 0 0 1.98-11.28 1.46-15.1-.07-.52-.12-.67-.26-1.08l-.17-.44c-.54-1.25-1.6-2.57-3.26-2.5l-.98-.03h-.02c-1.86 0-3.36.95-3.76 2.36-1.2 4.44.04 11.09 2.29 19.69l-.58 1.4c-1.61 3.94-3.63 7.9-5.41 11.39l-.23.45c-1.88 3.67-3.58 6.79-5.13 9.43l-1.59.84c-.12.06-2.85 1.51-3.49 1.89-5.43 3.25-9.03 6.93-9.63 9.85-.19.94-.05 2.13.92 2.68l1.54.78c.67.33 1.38.5 2.1.5 3.87 0 8.36-4.82 14.55-15.62 7.14-2.32 15.28-4.26 22.41-5.32 5.43 3.05 12.11 5.18 16.33 5.18.75 0 1.4-.07 1.92-.21.81-.22 1.49-.68 1.91-1.3.82-1.23.98-2.93.76-4.67zM36.49 99.33c.7-1.93 3.5-5.75 7.63-9.13.26-.21.9-.81 1.48-1.37-4.32 6.89-7.21 9.63-9.11 10.5zM60.95 43c1.24 0 1.95 3.13 2.01 6.07.06 2.94-.63 5-1.48 6.53-.71-2.26-1.05-5.82-1.05-8.15 0 0-.05-4.45.52-4.45zm-7.3 40.14c.87-1.55 1.77-3.19 2.69-4.92 2.25-4.25 3.67-7.57 4.72-10.3 2.1 3.82 4.72 7.07 7.79 9.67.39.32.8.65 1.22.98-6.25 1.23-11.66 2.74-16.42 4.57zm39.43-.35c-.38.23-1.47.37-2.17.37-2.26 0-5.07-1.03-9-2.72 1.51-.11 2.9-.17 4.14-.17 2.27 0 2.94-.01 5.17.56 2.22.57 2.25 1.72 1.86 1.96z"
                            style="fill: #ff402f"
                          />
                        </svg>
                      </ng-container>
                    </ng-container>
                  </div>
                  <div class="mt-2 flex" *ngIf="node.lastUpdateDate !== ''">
                    <div class="flex items-center text-sm text-gray-500">
                      <app-calendar-solid-icon
                        size="20"
                        svgClass="flex-shrink-0 mr-1.5 text-gray-400"
                      ></app-calendar-solid-icon>
                      <p>
                        Last Updated on
                        <time datetime="2020-01-07">
                          {{ node.lastUpdateDate }}
                        </time>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<lib-footer></lib-footer>
